<template>
  <div :class="{'nav-open': $sidebar.showSidebar}"
    v-if="!getLoginAccount || getLongTokenMode || (getLoginAccount && getTeam != undefined)"
    >
    <notifications />
    <Snackbar ref="snackbar" />
    <!--
    <notifications transition-name="notification-list" transition-mode="out-in"></notifications>
    -->
    <router-view name="header">
    </router-view>
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component"></component>
      </transition>
    </router-view>
    <router-view name="footer">
    </router-view>
  </div>
  <div v-else><a href="/login"> Login first</a></div>
</template>

<script>
// Loading some plugin css asynchronously
import * as compare from 'node-version-compare';
import authServices from 'src/services/authServices';
import ConfigService from 'src/services/configService';
import Snackbar from 'src/components/UIComponents/Snackbar.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { Snackbar },
  data() {
    return {
      value: undefined,
      options: [
        {
          value: 'Option1',
          label: 'Option1',
        },
        {
          value: 'Option2',
          label: 'Option2',
        },
        {
          value: 'Option3',
          label: 'Option3',
        },
      ],


      heartbeatInterval: undefined,
      currentVersion: process.env.PACKAGE_VERSION || '0',
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoginAccount', 'getLongTokenMode']),
    // Any item in the config that is set to alert when its loaded
    // On unset they are moved to undefined
    ...mapGetters('team', ['getTeam']),
  },
  methods: {
    ...mapActions('auth', ['setLoggedIn', 'setLongTokenMode']),
    async loadData() {
      let version;
      try {
        version = await authServices.fetchVersion();
      } catch (err) {
        // TODO: if we get here things are broken.
        console.log('we have an error getting version on load', err);
        throw err;
      }
      // console.log(version.data.version, this.currentVersion);
      const r = compare(version.data.version, this.currentVersion) || 0;
      // console.log(r);
      if (r > 0) {
        location.reload();
      }
    },
    sendToLogin() {
      if (!window.location.href.includes('login')) {
        location.href = "/login";
      }
    }
  },
  async created() {
    // Verify we have a token first on created only
    const accessToken = localStorage.getItem('s2-access-token');
    if (accessToken == undefined) {
      // Need to be able to access public pages
      // We should sub class the routes to lock this down
      // this.sendToLogin();
      return;
    }

    // Manually parse the expiration on the token
    var raw = accessToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    var jwt = JSON.parse(decodeURIComponent(atob(raw).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('')));

    if (Date.now() >= jwt.exp * 1000) {
      // Token is expired just make them log in again
      this.sendToLogin();
      return;
    }

    if (accessToken && jwt.user_id == 0 && jwt.scope && jwt.scope == 'realtime') {
      // Realtime scope with user id 0 signals long token
      // We could make this more explicit
      // Long token for dashboard only
      // Logged in status is controlled by many diffent attrributes.
      // Some look at authAccount some at jwt. This needs to be cleaned up
      this.setLoggedIn({
        authAccount: {
          username: '',
          name: '',
          userId: 0,
          companyId: jwt.company_id,
        },
        authAcls: [],
        authBrands: [],
      });
      this.setLongTokenMode(true);
      // We dont load all the config.
      // We need agent data but that gets loaded in the store as needed.
      // TODO: We should load the minimum needed realtime data specifically.
      return;
    }

    // These 2 items are stored in localStorage to survive refreshes
    let authAccountRaw = localStorage.getItem('s2-auth-account');
    let authAclsRaw = localStorage.getItem('s2-auth-acls');
    let authBrandsRaw = localStorage.getItem('s2-auth-brands');
    let authAccount = { companyId: 0 };
    let authAcls = [];
    let brands = [];
    // Some where this is getting set as the string 'undefined'
    if (authAccountRaw != undefined && authAccountRaw != 'undefined') {
      try {
        authAccount = JSON.parse(authAccountRaw);
      }
      catch(e) {
        console.error("Invalid auth data in localStorage:" + e);
        authAccount = undefined;
        // Default to a basic object to prevent attr errors
      }
      try {
        authAcls = JSON.parse(authAclsRaw);
      }
      catch(e) {
        console.error("Invalid acl data in localStorage:" + e);
      }
      if (authBrandsRaw) {
        try {
          brands = JSON.parse(authBrandsRaw);
        }
        catch(e) {
          console.error("Invalid brands data in localStorage:" + e);
        }
      }
      if (!authAccount) {
        // Something is wrong
        this.sendToLogin();
        return;
      }
    }

    // If we cant load then the token or something is bad.
    try {
      await this.loadData();
    }
    catch (err) {
      console.log('we have an error while loading', err);
      // Dont load all the stuffs
      this.sendToLogin();
      return;
    }

    this.heartbeatInterval = setInterval(
      function () {
        this.loadData();
      }.bind(this),
      15 * 60 * 1000 // 15 minutes
    );

    if (authAccount.companyId != 0) {
      // Actions can only take a single param so make it an object
      this.setLoggedIn({
        authAccount: authAccount,
        authAcls: authAcls,
        authBrands: brands,
      });
      await ConfigService.loadConfig();
    }
  },
  beforeUnmount() {
    clearInterval(this.heartbeatInterval);
  },
};
</script>
<style lang="scss">
</style>
